var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnAlarm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.781 21.75A3.7 3.7 0 0 1 6.042 18H.659a.684.684 0 0 1-.6-.749V15c-.149-.3 0-.452.149-.6L2.3 12.45V9a7.6 7.6 0 0 1 6.734-7.5V0h1.5v1.5A7.482 7.482 0 0 1 17.258 9v3.45l2.093 1.95a1.169 1.169 0 0 0 .075.3 1.169 1.169 0 0 1 .075.3v2.4a.683.683 0 0 1-.747.6h-5.235a3.705 3.705 0 0 1-3.738 3.75zM7.539 18a2.305 2.305 0 0 0 2.242 2.25A2.306 2.306 0 0 0 12.024 18zM9.781 3A6 6 0 0 0 3.8 9v3.749c0 .158-.154.451-.3.451l-1.943 2.1v1.2H18v-1.2l-2.088-1.95a1.168 1.168 0 0 0-.074-.3 1.174 1.174 0 0 1-.075-.3V9a6 6 0 0 0-5.982-6z",
    transform: "translate(12 11)",
    style: {
      fill: "#505866"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 201",
    style: {
      fill: "none"
    },
    d: "M0 0h44v44H0z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAlarm);
export default __webpack_public_path__ + "static/media/icn_alarm.59c3acb6e3f2dfbd80d8da3f92cabb72.svg";
export { ForwardRef as ReactComponent };